<template>
  <div
    class="product-badge
      text-center w-auto rounded-md
      flex justify-center items-center text-EXPONDO-white"
    :class="[badgeClass, small ? 'px-2 py-1 text-xs' : 'px-2.5 py-1 text-sm h-7']"
  >
    <span>{{ $t(badgeTranslationKey) }}</span>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductCardBadge',
  props: {
    badgeClass: {
      type: String,
      required: true,
    },
    badgeTranslationKey: {
      type: String,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
});

</script>

<style lang="scss" scoped>
.product-badge {
  &--popular {
    @apply bg-EXPONDO-secondary;
  }

  &--new {
    @apply bg-EXPONDO-green;
  }

  &--sale {
    @apply bg-EXPONDO-red;
  }

  &--bware {
    @apply bg-EXPONDO-primary-80;
  }

  &--top-rated {
    @apply bg-EXPONDO-grey;
  }

  &--black-friday {
    @apply bg-EXPONDO-black;
  }

  &--cyber-week {
    @apply bg-EXPONDO-secondary-medium;
    @apply text-EXPONDO-black;
  }

  &--secondary-medium {
    @apply bg-EXPONDO-secondary-medium;
    @apply text-EXPONDO-primary;
  }

  &--custom-badge {
    @apply bg-EXPONDO-yellow;
    @apply text-EXPONDO-primary;
  }
}
</style>
